import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => {
  return {
    margin: theme.spacing(2),
  };
});
export default StyledCard;
